import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NotificationsService, NotificationType } from 'angular2-notifications';
import { ApiResponse } from '../models/common/apiResponse';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
    constructor(private readonly notificationsService: NotificationsService, private readonly router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap(
                (event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        this.handleSuccess(event);
                    }
                },
                (err: any) => {
                    if (err instanceof HttpErrorResponse) {
                        switch (err.status) {
                            case 401:
                                this.handleUnathorized(err);
                                break;
                            case 404:
                                this.handleNotFound(err);
                                break;
                            case 408:
                                this.handleTimeout(err);
                                break;
                            case 500:
                                this.handleServerError(err);
                                break;
                            default:
                                this.handleGeneric(err);
                                break;
                        }
                    }
                }
            )
        );
    }


    private handleSuccess(response: HttpResponse<any>) {
        if (response && response.body) {
            const messages = response.body.messages;

            if (messages) {
                messages.map((message) => {
                    this.notificationsService.success('Success', message);
                });
            }
        }
    }

    private handleUnathorized(response: HttpErrorResponse) {
        this.notificationsService.bare('Login Expired',
            `Your login has expired. Please log in again to access this page.`);
        this.router.navigate(['/account/login']);
    }

    private handleNotFound(response: HttpErrorResponse) {
        this.notificationsService.error('Not Found',
            `Could not find the resource at ${response.url}, please contact a system administrator`);
    }

    private handleTimeout(response: HttpErrorResponse) {
        this.notificationsService.error('Timeout', `Request to ${response.url} timed out, please try again`);
    }

    private handleServerError(response: HttpErrorResponse) {
        const messages = response.error ? (response.error as ApiResponse).messages : null;

        if (messages) {
            messages.map((message) => {
                this.notificationsService.error('Server Error', message);
            });
        } else {
            this.notificationsService.bare('',
                `A problem has occurred trying to access this page. Please refresh the page.`);
        }
    }

    private handleGeneric(response: HttpErrorResponse) {
        const messages = response.error ? (response.error as ApiResponse).messages : null;

        if (messages) {
            const isDuplicateEmail = response.url && response.url.includes('firstStepComplete') &&
                messages.some((m: string) => m.toLowerCase().includes('already in use') || m.toLowerCase().includes('already exists'));

            if (isDuplicateEmail) {
                this.notificationsService.html(
                    'An account already exists with this email address, please <a href="/members/#/account/login">click here</a> to login',
                    NotificationType.Error,
                    { timeOut: 10000, showProgressBar: true, pauseOnHover: true }
                );
            } else {
                messages.map((message) => {
                    this.notificationsService.error('Error', message, {
                        timeOut: 10000,
                        showProgressBar: true,
                        pauseOnHover: true,
                    });
                });
            }
        } else if (response.error.error === 'invalid_grant') {
            //An error message is already displayed where this kind of error is important, so do nothing.
            return;
        } else {
            //const errorMessage = response.url
            //    ? `An unknown error with a status code of ${response.status} occured accessing ${response.url}, please contact a system administrator`
            //    : 'An unknown error occured, please contact a system administrator';

            this.notificationsService.bare('', 'A problem has occurred trying to access this page. Please refresh the page.');
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/interceptors/response.interceptor.ts